class ProductInventory extends HTMLElement {
  static observedAttributes = ["variant", "threshold"];

  constructor () {
    super();

    this.script = this.querySelector('script');
    this.data = this.script ? JSON.parse(this.script.innerText) : null;
    this.variant = this.getAttribute('variant') ?? null;
    this.threshold = this.getAttribute('threshold') ?? 0;

    this.parentEl = this.parentElement;
    this.containerEl = this.querySelector('.icon-and-text');
    this.textEl = this.querySelector('[data-product-inventory]');
    this.message = this.textEl.dataset.message ?? '';
  }

  connectedCallback() {
    document.addEventListener('variant:change', (e) => {
      this.setAttribute('variant', e.detail.variant.id);
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'variant') this.render(newValue);
  }

  render(id) {
    if(!id || !this.data) return;

    const threshold = Number(this.threshold);
    const found = this.data.find((v) => v.id === Number(id));
    const management = found.inventory_management ?? 'none';
    const policy = found.inventory_policy ?? 'none';
    const qty = found.inventory_quantity ?? 0;

    if(management !== 'shopify') return;

    if (qty > 0 && qty <= threshold){
      if (this.containerEl && !this.containerEl.classList.contains('inventory--low')) {
        this.containerEl.classList.add('inventory--low');
      }
      if (this.textEl) {
        this.textEl.innerHTML = this.message.replaceAll('[stock]', qty);
      }
      this.parentEl.classList.remove('hidden');
    } else {
      this.parentEl.classList.add('hidden');
    }
  }
}
if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory)
}